module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.exerciseReports')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.reports.reported')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.reports.user')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.reports.status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.reports.comment')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reports), function(report) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(report.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(report.createdAt)))]), _vm._v(" "), (report.user) ? _c('td', [_vm._v(" " + _vm._s(report.user.firstName) + " " + _vm._s(report.user.lastName) + " ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(report.exerciseId)
        }
      }
    }, [_vm._v(_vm._s(report.description))])]), _vm._v(" "), _c('td', [(report.status == 'resolved') ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeStatus(report.id, report.status)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.reports.compareResolved')))]) : (report.status == 'pending') ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeStatus(report.id, report.status)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.reports.comparePending')))]) : (report.status == 'ignored') ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeStatus(report.id, report.status)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.reports.compareIgnored')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteReport(report.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-show"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.preview')) + " [ " + _vm._s(_vm.CelotnaNaloga.id) + " ] ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('exercise', {
    attrs: {
      "bareBonesExercise": _vm.CelotnaNaloga
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-edit"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.editexercise.prompt')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('editexercise')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(this.$t('pages.profile.update')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d79d16d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d79d16d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Reports.vue
// module id = 1475
// module chunks = 1